import classNames from 'classnames';
import type { ReactNode } from 'react';

import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from '@revelio/ui';

import styles from './config-section.module.css';
import labelStyles from './section-label.module.css';

type ConfigSectionProps = {
  title: ReactNode;
  /** Names the section for the Customize accordion's `defaultValue`. */
  value?: string;
  /** Format and Color keep Chakra's default top border; the others drop it. */
  withTopBorder?: boolean;
  children: ReactNode;
};

/** One Customize section; must sit inside the panel's `Accordion`. */
export const ConfigSection = ({
  title,
  value,
  withTopBorder = false,
  children,
}: ConfigSectionProps) => (
  <AccordionItem
    value={value}
    className={styles.section}
    data-top-border={withTopBorder || undefined}
  >
    <h2>
      <AccordionButton className={styles.sectionToggle}>
        <span className={classNames(labelStyles.sectionLabel, styles.title)}>
          {title}
        </span>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel>{children}</AccordionPanel>
  </AccordionItem>
);
